import React, { useState, useEffect } from 'react'

import { makeStyles } from '@material-ui/core/styles'
import { Chip, colors } from '@mui/material'
import { Col, Span } from 'components'
import { Controller } from 'react-hook-form'
import { FORMAT, COLORS, SPACING } from 'utils'
import { FONTS } from 'utils'
import {
  InputStyles,
  InputLabelCustom,
  CustomInput,
  CustomChip
} from './styles'
import { CSSProperties } from '@material-ui/core/styles/withStyles'

const useStyles = makeStyles((theme) => ({
  chip: {
    margin: theme.spacing(0.5, 1, 0.5, 0)
  }
}))

const patterns = {
  email: RegExp(/.*@.*\.[A-Za-z]{2}.*/g)
}
//let transicao = false;
interface ToastInterface {
  top?: string,
  right?: string,
  message?: string,
  show: boolean,
  style?: React.CSSProperties
}
const Toast = ({ message, show, style = {}, top, right = '3.1%' }: ToastInterface) => {
  const [visible, setVisible] = useState(show);

  useEffect(() => {
    if (show) {
      return setVisible(true);
    }
    else {
      const timer = setTimeout(() => setVisible(false), 500); // Tempo da animação de saída
      return () => clearTimeout(timer);
    }
  }, [show]);

  const defaultStyle: React.CSSProperties = {
    position: 'absolute',
    // Mantém como está, pois já é relativo ao tamanho da viewport
    top: top || 'auto',
    right: right || 'auto', // Alterado de rem para vw
    backgroundColor: 'white',
    marginTop: '23px',
    color: COLORS.error,
    fontWeight: 'bold',
    fontFamily: 'arial',
    fontSize: '1rem', // Alterado de rem para vw para ajustar com o zoom
    padding: '0.7rem', // Alterado de remx para vw, e corrigido o typo de 'remx' para 'rem'
    paddingLeft: '0.1rem',
    paddingRight: '0.1rem',
    zIndex: 1000, // Controla a ordem de sobreposição dos elementos
    opacity: show ? 1 : 0,
    transition: 'opacity 0.5s ease-in-out, transform 0.5s ease-in-out', // Combina as transições em uma única propriedade
    width: '20%',
    textAlign: 'center',
    margin: '0.2rem',
    borderRadius: '30px',
    border: '0.1rem solid',
    borderColor: COLORS.error,
    boxShadow: '0px 2px 4px rgba(50, 15, 0, 0.25)',
    transform: show ? 'translateX(0)' : 'translateX(100%)', // Define a transformação para entrada e saída
    animation: show ? 'slideIn 0.5s ease-in-out' : 'slideOut 0.5s ease-in-out'
  }
  return (
    visible && (
      <div style={{ ...defaultStyle, ...style }}>
        {message}
      </div>
    )
  );
};

// Defina as animações usando @keyframes
const styles = `
@keyframes slideIn {
  from {
    transform: translateX(100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}

@keyframes slideOut {
  from {
    transform: translateX(0);
    opacity: 1;
  }
  to {
    transform: translateX(100%);
    opacity: 0;
  }
`;

// Adicione as animações ao documento
const styleSheet = document.createElement("style");
styleSheet.type = "text/css";
styleSheet.innerText = styles;
document.head.appendChild(styleSheet);

interface ChipInputProps extends InputStyles {
  mensagem?: string
  control?: any
  errors?: any
  formValue?: string
  value?: string[]
  required?: boolean
  type?: string
  name?: string
  disabled?: boolean
  maxLength?: number
  defaultValue?: string[]
  ref?: any
  placeholder: string
  label?: string
  onBlur?: (_e: any) => void
  onKeyUp?: (_e: any) => void
  onFocus?: (_e: any) => void
  onChange?: (_tags: string[]) => void
  onClickIcon?: () => void
  only?: 'email'
  isDisabled?: boolean
  enableInsertOnEnter?: boolean
  flExclusao?: boolean[]
  setFlExclusao?: any,
  setValue?: any,
  ToastComponent?: any
}

const ChipInput: React.FC<ChipInputProps> = ({
  mensagem,
  control,
  label,
  errors,
  required,
  disabled = false,
  type,
  placeholder,
  marginTop,
  onChange,
  onBlur,
  marginBottom,
  onFocus,
  onKeyUp,
  marginLeft,
  marginRight,
  formValue,
  enableInsertOnEnter = false,
  maxLength,
  defaultValue = [],
  ref,
  only,
  isDisabled = false,
  flExclusao,
  setFlExclusao,
  setValue,
  ToastComponent,
  ...props
}) => {
  const classes = useStyles()

  const [inputValue, setInputValue] = useState<string>('')
  const [selectedItems, setSelectedItems] = useState<string[]>([])
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');

  const exibirToast = (message: string) => {
    setShowToast(true);
    // transicao = true;
    setToastMessage(message);
    setTimeout(() => {
      setShowToast(false);
      // transicao = false;
    }, 3500)
  };

  const hasError = errors && errors[formValue]

  const handleKeyDown = (event, callback: (_tags: string[]) => void) => {
    const isEnabledOnEnter = event.key === 'Enter' && enableInsertOnEnter
    if (event.target.value == null) {
      return
    }

    if (
      isEnabledOnEnter ||
      event.keyCode === 32 ||
      event.keyCode === 0 ||
      event.target.value[event.target.value - 1] === ' '
    ) {
      const newTag = event.target.value.trim()

      if (selectedItems.includes(newTag) || !newTag) {
        setInputValue('');
        exibirToast("O e-mail fornecido já está cadastrado nesse contrato!");
        return
      }

      setSelectedItems((prevState) => [...prevState, newTag])
      if (flExclusao)
        setFlExclusao((prevState) => [...prevState, false])

      callback([...selectedItems, newTag])

      setInputValue('')
    }

    if (selectedItems.length > 0 && !inputValue && event.key === 'Backspace') {
      callback(selectedItems.slice(0, -1))

      setSelectedItems((prevState) => prevState.slice(0, -1))
      if (flExclusao)
        setFlExclusao((prevState) => prevState.slice(0, -1))
    }
  }

  const handleDelete = (
    selectedTag: string,
    callback: (_tags: string[]) => void
  ): void => {
    if (flExclusao) {

      const i = selectedItems.findIndex((tag) => tag === selectedTag)

      const newFl = flExclusao.map((value, index) => index == i ? true : value)

      setFlExclusao(newFl)
      setSelectedItems((prevState) =>
        prevState.filter((tags) => tags)
      )
      callback(selectedItems)
      return
    } else {
      setSelectedItems((prevState) =>
        prevState.filter((tags) => tags !== selectedTag)
      )
      callback(selectedItems.filter((tags) => tags !== selectedTag))
      return
    }
  }
  return (
    <>
      <Col
        marginBottom={marginBottom}
        marginLeft={marginLeft}
        marginRight={marginRight}
        marginTop={marginTop}
      >
        <InputLabelCustom hasError={hasError}>
          {FORMAT.capitalizeString(label) || ''}
        </InputLabelCustom>
        {control ? (
          <Controller
            name={formValue}
            control={control}
            defaultValue={defaultValue || []}
            render={({
              field: { onChange, value },
              fieldState: { error }
            }) => {
              setSelectedItems(value)
              return (
                <CustomInput
                  {...props}
                  onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                    if (event.target?.value?.includes(';')) {
                      const emails = event?.target?.value
                        ?.split(';')
                        ?.filter((e) => /.*@.*\.[A-Za-z]{2}/g.test(e))

                      onChange([...new Set([...value, ...emails])])
                      setInputValue('')
                    } else {
                      setInputValue(event.target.value.replace(';', ''))
                    }
                  }}
                  variant="standard"
                  disabled={disabled}
                  onBlur={onBlur}
                  onKeyUp={onKeyUp}
                  fullWidth
                  marginBottom={hasError && SPACING.spacing5}
                  hasError={hasError}
                  value={inputValue}
                  onFocus={onFocus}
                  onKeyDown={(event) => handleKeyDown(event, onChange)}
                  type={type || 'text'}
                  placeholder={placeholder}
                  error={!!error}
                  ref={ref}
                  inputProps={{ maxLength: maxLength }}
                  InputProps={{
                    startAdornment:
                      value.length > 0 &&
                      value.map((item, index) => (
                        flExclusao ? (
                          flExclusao[index] !== true && (
                            <Chip
                              key={item}
                              disabled={isDisabled}
                              tabIndex={-1}
                              label={item}
                              className={classes.chip}
                              onDelete={() => handleDelete(item, onChange)}
                            />
                          )
                        ) :
                          (
                            <Chip
                              key={item}
                              disabled={isDisabled}
                              tabIndex={-1}
                              label={item}
                              className={classes.chip}
                              onDelete={() => handleDelete(item, onChange)}
                            />
                          )
                      ))
                  }}
                />
              )
            }}
            rules={{ required }}

          />
        ) : (
          <CustomInput
            {...props}
            defaultValue={defaultValue || []}
            disabled={disabled}
            type={type || 'text'}
            marginBottom={hasError && SPACING.spacing5}
            value={inputValue}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              setInputValue(e.target.value)
            }
            onKeyDown={(event) => handleKeyDown(event, onChange)}
            placeholder={placeholder}
            hasError={hasError}
            variant="standard"
            inputProps={{ maxLength }}
            onBlur={onBlur}
            ref={ref}
            InputProps={{
              startAdornment: selectedItems.map((item, index) => (
                flExclusao[index] !== true &&
                <CustomChip
                  key={item}
                  disabled={isDisabled}
                  tabIndex={-1}
                  label={item}
                  className={classes.chip}
                  onDelete={() => handleDelete(item, onChange)}
                />
              ))
            }}
          />
        )}
        {hasError && (
          <>
            <Span
              text={errors[formValue]?.message || 'Erro.'}
              color={COLORS.error}
            />
          </>
        )}
        {mensagem && <Span text={mensagem} color={COLORS.darkGray} />}
        {showToast && <Toast message={toastMessage} show={showToast} style={{}} />}
      </Col >
    </>
  )
}
export { Toast }
export default ChipInput
